import { FC } from 'react'
import styles from './footer-bottom.module.scss'
import classNames from '@/utils/helpers/class-names.helper'
import { useTranslation } from 'react-i18next'
import Link from 'next/link'
import useI18nPath from '@/hooks/i18n-path.hook'

type FooterBottomProps = {}

const FooterBottom: FC<FooterBottomProps> = ({}) => {
  const { t } = useTranslation()
  const { getHrefLang } = useI18nPath()

  return (
    <div className={styles.bottom}>
      <div className={classNames(styles['text-box'], styles.text, '_main', '_copy')}>
        <p className={styles.text}>© 2000 – 2025 Majordomo</p>
        <p className={styles.text}>
          <Link href={getHrefLang('/company/rules#0')} className={classNames(styles.link)}>
            {t('user-agreement')}
          </Link>
        </p>
      </div>
      <div className={classNames(styles['text-box'], styles.text, '_main', '_address')}>
        <p
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: t('our-address').replace(/itemprop=".*?"/g, '') }}
        ></p>
        <p className={styles.text}>{t('postal-address')}</p>
      </div>
      <div className={classNames(styles['text-box'], styles.text, '_main', '_news')}>
        <Link href={getHrefLang('/news')} className={classNames(styles.link, '_accent')}>
          {t('last-news')}
        </Link>
      </div>
    </div>
  )
}

export default FooterBottom
